<template>
	<div class="excel-export">
		<button aria-label="Export Results to CSV" class="excel-export-btn" @click="exportToExcel"><font-awesome-icon icon="file-excel" /></button>

		<modal v-if="isModalVisible" @close="closeModal" @backgroundClicked="closeModal">
			<h2 slot="header">Export Results</h2>
			<div slot="body">
				<div class="container">
					<p v-if="!hasFileGenerated">Generating file</p>
					<font-awesome-icon icon="spinner" v-if="!hasFileGenerated" />
					<p v-if="hasFileGenerated"><a @click="getFile" class="pointer">Download results Spreadsheet</a></p>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
	import Modal from '../reusable/Modal'
	import { blob2file } from '../../helpers/helpers'

	export default {
		name: 'ExportResults',
		data() {
			return {
				isModalVisible: false,
				hasFileGenerated: false,
				fileName: null,
				hash: null
			}
		},
		components: {
			FontAwesomeIcon, Modal
		},
		props: ['companySearchId', 'selectedLayout', 'selectedResults', 'selectedDealResults'],
		methods: {
			getFile() {
				this.$store.dispatch('filemodule/getFile', [this.fileName, this.hash]).then(response => {	
					blob2file(response.data, this.fileName);
				});
			},
			exportToExcel() {
				this.showModal();

				if (this.selectedResults.length > 0 || this.selectedDealResults.length > 0) {  //checks that there is even a need to do selective export (before deciding which param to send to endpoint)
					console.log("selective Export");
					if (this.selectedLayout == 7)
					{
						this.$store.dispatch('exportmodule/selectedSearchResultsToExcel', [this.companySearchId, this.selectedLayout, this.selectedDealResults]).then(file => {							
							console.log(file);
							this.fileName = file.fileName;
							this.hash = file.hash;
							this.hasFileGenerated = true;
						});
					}
					else
					{
						this.$store.dispatch('exportmodule/selectedSearchResultsToExcel', [this.companySearchId, this.selectedLayout, this.selectedResults]).then(file => {
							console.log(file);
							this.fileName = file.fileName;
							this.hash = file.hash;
							this.hasFileGenerated = true;
						});
					}
				}
				else {
					console.log("full Export");
					this.$store.dispatch('exportmodule/searchResultsToExcel', [this.companySearchId, this.selectedLayout]).then(file => {
						console.log(file);
						this.fileName = file.fileName;
						this.hash = file.hash;
						this.hasFileGenerated = true;
					});
				}
			},
			showModal() {
				this.isModalVisible = true
			},
			closeModal() {
				this.isModalVisible = false;
				this.hasFileGenerated = false;
				this.link = '';
			}
		}
	}
</script>

<style lang="scss" scoped>
	.excel-export-btn {
		background: none;
		border: 0;
		flex-grow: 0.3;
		text-align: right;
		cursor:pointer;
		svg {
			width: 25px;
			height: 25px;
			color: #3fa71e;
		}
	}

	.container{
		display:flex;
	}

	.fa-spinner{
		margin-top:10px;
		margin-left:15px;
	}

	.pointer {
		cursor: pointer;
	}

</style>
